export class Uploaddocument {
  headOfBase64: String | ArrayBuffer;
  headOfFilename: string;
  headOfBase64Override: boolean;
}
